import { render } from "./SelfieCamera.vue?vue&type=template&id=46c836ac&scoped=true"
import script from "./SelfieCamera.vue?vue&type=script&lang=js"
export * from "./SelfieCamera.vue?vue&type=script&lang=js"

import "./SelfieCamera.vue?vue&type=style&index=0&id=46c836ac&scoped=true&lang=css"

import exportComponent from "/home/runner/work/j-nuts-memory-join/j-nuts-memory-join/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c836ac"]])

export default __exports__